// Clients we have worked with
export const clients = [
  { name: "Prime Time", category: "Entertainment" },
  { name: "BBC Live", category: "Broadcasting" },
  { name: "Welch's", category: "Beverages" },
  { name: "Hayes", category: "Corporate" },
  { name: "Balfour Wines", category: "Wine" },
  { name: "Jake's Cider", category: "Cider" },
  { name: "Commonwealth Games 2022", category: "Sports" },
  { name: "F45", category: "Fitness" },
  { name: "NEC", category: "Events" },
  { name: "RIAT 2024", category: "Aviation" },
  { name: "LUMOS Experiences", category: "Events" }
];
